var $99fc4c101d92daf3$exports = {};
$99fc4c101d92daf3$exports = {
    "Empty": `Vide`
};


export {$99fc4c101d92daf3$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
